import { render, staticRenderFns } from "./langButton.vue?vue&type=template&id=31b7dd27&scoped=true&"
import script from "./langButton.vue?vue&type=script&lang=js&"
export * from "./langButton.vue?vue&type=script&lang=js&"
import style0 from "./langButton.vue?vue&type=style&index=0&id=31b7dd27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7dd27",
  null
  
)

export default component.exports